import type {
  QmsQualitySignatureMeaning,
  QmsTicket,
  QmsTicketStatus,
  QmsWorkflowAction,
} from '../types/qms.types';

export function isProtectedQualityEvent(ticket: Pick<QmsTicket, 'type' | 'change_control_required'>) {
  return ticket.type === 'capa' || ticket.change_control_required === true;
}

export function getQmsWorkflowMeaning(
  action: QmsWorkflowAction,
  targetStatus?: QmsTicketStatus,
  currentStatus?: QmsTicketStatus,
): QmsQualitySignatureMeaning {
  if (action === 'approve_change') return 'approval';
  if (action === 'reject_change') return 'review';
  if (action === 'verify_effectiveness') return 'verification';
  if (targetStatus === 'validated_closed') return 'verification';
  if (targetStatus === 'complete') return 'implementation';
  if (targetStatus === 'ready_to_test') return 'approval';
  if (
    targetStatus === 'submitted'
    || currentStatus === 'ready_to_test'
    || currentStatus === 'validated_closed'
  ) {
    return 'review';
  }
  return 'responsibility';
}

export function getQmsStatusLabel(status?: QmsTicketStatus) {
  return (status || '').replace(/_/g, ' ').replace(/\b\w/g, (letter: string) => letter.toUpperCase());
}
